<div class="jumbotron text-center">
  <h1 class="display-4">Welcome to Curb Fleet Dashboard v2</h1>
  <p class="lead">Manage your fleet locations with ease</p>
  <hr class="my-4">
  <p>This dashboard allows you to view and manage locations across your fleets.</p>
  <div *ngIf="!isAuthenticated" class="mt-4">
    <button class="btn btn-primary btn-lg" (click)="login()">Login to Get Started</button>
  </div>
</div>

<div class="row mt-5">
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Fleet Management</h5>
        <p class="card-text">Select from your available fleets and manage their locations.</p>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Location Tracking</h5>
        <p class="card-text">View detailed information about each location in your fleet.</p>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Data Visualization</h5>
        <p class="card-text">Powerful grid views to help you analyze your fleet data.</p>
      </div>
    </div>
  </div>
</div>
